"use strict";

export default {
  getWidth(percentage = 100) {
    return (window.innerWidth / 100 ) * percentage;
  },
  getHeight(percentage = 100) {
    return (window.innerHeight / 100 ) * percentage;
  }
};